var ArchiveEnvironmentDialogModule = /** @class */ (function () {
    function ArchiveEnvironmentDialogModule() {
    }
    return ArchiveEnvironmentDialogModule;
}());
export { ArchiveEnvironmentDialogModule };
